import axios from "axios";
import { commonUtil } from "../utils";
let tokenStatus = 1;
// 1: binh thuong
// 2: dang lay token
let getTokenFromServerPromise: any = null;

const RequestAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

RequestAPI.interceptors.request.use(async (config) => {
  const accessToken = await getToken();
  config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : "";
  config.headers["Accept-Language"] =
    localStorage.getItem("i18nextLng") || "vi";
  config.headers["Booking-Platform"] = "atadi";
  return config;
});

const getToken = async () => {
  if (tokenStatus === 1) {
    const token = commonUtil.getAccessToken();
    if (!token) {
      const refreshToken = commonUtil.getRefreshToken();
      if (!refreshToken) {
        commonUtil.deleteSession();
        return;
      } else {
        getTokenFromServerPromise = getTokenFromServer(refreshToken);
        await getTokenFromServerPromise;
      }
    }
  } else if (tokenStatus === 2) {
    // Nếu đang lấy thì đợi trả về token, sau đó trả về token mới
    await getTokenFromServerPromise;
  }
  // Không thì trả về token cũ
  return commonUtil.getAccessToken();
};

const getTokenFromServer = async (refreshToken: string) => {
  tokenStatus = 2;
  try {
    const res = await axios({
      url:
        process.env.REACT_APP_API_URL + `/core-user-service/auth/refreshToken`,
      method: "POST",
      data: { refreshToken },
    });
    if (res.data && res.data.status === "success") {
      commonUtil.saveSession(
        res.data.data.access_token,
        res.data.data.refresh_token,
        res.data.data.expires_in
      );
      tokenStatus = 1;
      return;
    } else {
      commonUtil.deleteSession();
      return;
    }
  } catch (error) {
    commonUtil.deleteSession();
    return;
  }
};

export default RequestAPI;
